export const login = {
    sign_in: 'Sign in',
    email:'Email',
    password:'Password',
    forgot_password: 'Forgot your password?',
}